import { TooltipState, PositionY, PositionX } from './Tooltip.d';

function isBaseOnCenter(baseClientRect: DOMRect, screenWidth: number) {
  return (
    baseClientRect.x + 16 > (screenWidth / 5) * 2 && baseClientRect.x + 16 < (screenWidth / 5) * 4
  );
}

function isLeft(tooltipClientRect: DOMRect) {
  return tooltipClientRect.x < 0;
}

function isRight(tooltipClientRect: DOMRect, screenWidth: number) {
  return tooltipClientRect.x >= screenWidth - tooltipClientRect.width;
}

function isUp(tooltipClientRect: DOMRect) {
  return tooltipClientRect.y > tooltipClientRect.height;
}

function getHorizontalPosition(
  positionX: 'center' | 'left' | 'right',
  tooltipClientRect: DOMRect,
  baseClientRect: DOMRect,
  screenWidth: number,
) {
  if (isBaseOnCenter(baseClientRect, screenWidth)) {
    return 'center';
  }

  if (isLeft(tooltipClientRect)) {
    return 'left';
  }

  if (isRight(tooltipClientRect, screenWidth)) {
    return 'right';
  }

  return positionX;
}

function getVerticalPosition(tooltipClientRect: DOMRect) {
  if (isUp(tooltipClientRect)) {
    return 'up';
  }

  return 'down';
}

export function getTooltipPosition(
  tooltipClientRect: DOMRect,
  baseClientRect: DOMRect,
  currentState: TooltipState,
): Omit<TooltipState, 'isVisible'> {
  const screenWidth = window.innerWidth;
  const { positionX } = currentState;

  const horizontalPosition: PositionX = getHorizontalPosition(
    positionX,
    tooltipClientRect,
    baseClientRect,
    screenWidth,
  );

  const verticalPosition: PositionY = getVerticalPosition(tooltipClientRect);

  return {
    positionX: horizontalPosition!,
    positionY: verticalPosition!,
  };
}
